<template>
  <div class="business">
    <div class="top-bar">
      <span @click="cancel">
        <i class="left"></i>
      </span>
      <span class="heading_new">Assign Fixed Non CTC Components</span>
      <span class="spacer" />
    </div>
    <div class="card margintop-30">
      <div class="image">
        <img v-if="employeeObject.photo_url" :src="employeeObject.photo_url" class="alignImage" />
        <img v-else src="@/assets/user.svg" class="alignImage" />
      </div>
      <div class="emp-details">
        <span>
          <b>{{employeeObject.name}}</b>
        </span>
        <br />
        <span class="details">{{employeeObject.code}}</span>
        <br />
        <span class="details">{{employeeObject.email_id}}</span>
        <br />
        <br />
      </div>
    </div>

    <section class="main-content-section margin-left-20">
      <tl-tabs :tabs="tabs" :customclass="true" :showcount="false">
        <tl-tab>
          <assign-non-ctc-components-to-employees></assign-non-ctc-components-to-employees>
        </tl-tab>
        <!-- <tl-tab>
          <components-log></components-log>
        </tl-tab>-->
      </tl-tabs>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
// import componentsLog from "./componentsLog.vue";
import assignNonCtcComponentsToEmployees from "./assignNonCTCcomponentsToEmployees.vue";
export default {
  components: {
    // componentsLog,
    assignNonCtcComponentsToEmployees
  },
  data() {
    return {
      employeeObject: {
        id: null,
        name: null,
        code: null,
        email_id: null,
        assignedComponentsList: []
      },
      tabs: [
        {
          header: "Assign New"
        }
        // {
        //   header: "Components Revision Log"
        // }
      ]
    };
  },

  activated() {
    this.employeeObject = this.getRecord;
  },

  computed: {
    ...mapState({
      orgData: state => state.onboard.organization.state.data[0],
      getRecord: state =>
        state.dashboard.payroll.utilities.assignFixedNonCTCcomponents.record
    })
  },

  methods: {
    getEmpEncryptedString() {
      return this.$route.query.employee;
    },

    cancel() {
      this.refresh();
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/assignFixedNonCtcComponents`
      });
    },

    refresh() {}
  }
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  max-width: 300px;
  margin-right: 12px;
  height: auto;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  margin-left: 20px;
}

.image {
  .alignImage {
    width: 90px;
    height: 90px;
    margin: 10px;
    border-radius: 50px;
  }
}

.top-bar {
  height: auto;
  padding: 20px;
  margin-left: 20px;
  background-color: #34c0be;
  display: flex;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.emp-details {
  padding: 25px 0 0 10px;
  color: #535353;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.business {
  width: 100%;
  height: 100%;
}

.margin-left-20 {
  margin-left: 20px;
}
</style>
